module.exports = __webpack_public_path__ + "img/01-full.f8648487.jpg";